<template>
  <div class="d-flex align-items-center">
    <ad-rotator selector=".small-advertise" :showImmediately="true">
    </ad-rotator>
  </div>
</template>

<script>
import AdRotator from "@/shared/AdsRotator.vue";

export default {
  name: 'MarketingBanner',
  components: {AdRotator}
}
</script>
